
import TableList from "@components/templates/tablelist";
import { HttpGetRecommendList,HttpDeleteRecommendOne,HttpCancelRecommendOne,HttpCheckRecommend,HttpSubmitRecommend, HttpUnCategory } from "@/service/proddevelop";
import { HttpGetCategories } from '@/service/products/allproducts'
// import { HttpAccountType } from '@/service/boss/allot';
import { mapState,mapGetters } from "vuex";
import mixin from '../mixins'
import comIndex from './update'
import compAlertpass from './alertpass';
// 搜索品类
import searchCategory from "../../products/searchcategory/index";
export default {
    mixins: [TableList,mixin],
    components: {
        comIndex,
        compAlertpass,
        searchCategory
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: {show: true},
            Tabs: {show: true},
            formData:{
                search:{
                }
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            exportdata: {},
            Plugins: {show: true},
            erpSkusList:[],
            category:'',
            categoryList:[],
            EQ_categoryId: 0
        }
    },
    created(){
        this.getcategory()
    },
    methods: {
        ajaxRequest: HttpGetRecommendList,
        interceptRequest(params) {
            // 暂时解决点击更多搜索引发的errorCode无法传递现象，待彻底解决
            if (params.search.daiyuzhuan=== 0) {
                params.search.EQ_isPreselection = 0;
                params.search.EQ_status = 2
            }
            if (params.search.EQ_categoryId && this.EQ_categoryId) {
                params.search.EQ_categoryId = this.EQ_categoryId;
            }
            // return search
            params.precoding = params.search.precoding
            delete params.search.precoding

            delete params.search.daiyuzhuan
            this.exportdata = params

            return params
        },
        // 全部按钮点击操作
        handleOperates(params="", type,batch) {
            if(batch===true){
                params=(params||this.checkedData.join(','))+'';
                if(!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'recommendUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "query":
                    this.operate = {
                        title:'查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    var url=this.$router.resolve({
                        name: "recommendUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "allsubmit":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "提交审核",
                        width: 460,
                        params:{ids:params},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpSubmitRecommend
                    };
                    break;
                case "allaudit":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        title: "批量审核",
                        width: 460,
                        params:{statusId:2,ids:params},
                        formdata:[
                            {
                                tag: "vSelect",
                                key: "categoryId",
                                options: this.categoryList.map(item=>{
                                    return {
                                        value:item.id,
                                        label:item.code+'-'+item.name
                                    }
                                }),
                                labelWidth: 'auto',
                                span: 24,
                                label: "品类",
                                formItem: {
                                    tip: '<div class="color-error">填写后会覆盖所勾选数据的品类</div>',
                                },
                                required:false,
                            },
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注",
                                required:false,
                            }
                        ],
                        ajaxRequest:HttpCheckRecommend
                    };
                    break;
                case "allcancel":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "批量取消",
                        width: 460,
                        params:{ids:params},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "取消原因"
                            }
                        ],
                        ajaxRequest:HttpCancelRecommendOne
                    };
                    break;
                case "allrejected":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "批量驳回",
                        width: 460,
                        params:{statusId:3,ids:params},
                        formdata:[
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: "备注"
                            }
                        ],
                        ajaxRequest:HttpCheckRecommend
                    };
                    break;
                case "alldelete":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "删除",
                        width: 460,
                        params:{id:params},
                        ajaxRequest:HttpDeleteRecommendOne
                    };
                    break;
                case 'exportQuery':
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/productDevelopmentRecommend/exportByFilter", {...this.exportdata}, {
                        executor: 'request', 
                        download: true,
                    }).catch(err => {
                        // this.$VMessage.error(err.message);
                    })
                break
                case "uncategory":
                    this.operate = {
                        show: true,
                        alert: "warning",
                        title: "品类",
                        width: 460,
                        component: "compAlertpass",
                        showFooter:false,
                        orderid:params,
                        soucetype:'list'
                    };
                break;
                case "transprimary":
                    this.$router.push({
                        name: 'primaryUpdate',
                        params: { type: "add" },
                        query: { recommendid: params },
                    });
                    break;
                case "querypPrimaryBlank":
                    var url=this.$router.resolve({
                        name: "primaryUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                
            }
        },
        // 操作下的列表展示内容
        getOperateNodeMap(row){
            const { id,status } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query',
            },{
                label:'编辑',
                show:status == 0 || status == 3,
                to: {
                    name: 'recommendUpdate',
                    params: { type: 'edit' },
                    query: { id },
                },
            },{
                label:'转为预选',
                show:status == 2,
                params:id,
                operate:'transprimary'
            },{
                label:'提交审核',
                show:status == 0 || status == 3,
                params:id,
                operate:'allsubmit'
            },{
                label:'取消',
                show:status == 2 || status == 3,
                params:id,
                operate:'allcancel'
            },{
                label:'删除',
                show:status == 0,
                params:id,
                operate:'alldelete'
            }]
        },
        getcategory(){
            HttpGetCategories().then(res=>{
                this.categoryList = res.data.filter(item=>{
                    return item.level == 3
                })
            })
        },
        handleModalplat(){
            this.operate = {
                title:'搜索品类',
                show:true,
                width:650,
                component: "searchCategory",
                showFooter:false,
                on:{
                    'on-chosedata':(data)=>{
                        console.log('选择数据', data);
                        // this.$set(this.formData.search,'categoryName',data.code+'-'+data.name);
                        this.$refs.compSearchs.formData.EQ_categoryId = data.code+'-'+data.name
                        this.EQ_categoryId = data.id;
                    },
                }
            }
        },
    },
    computed: {
        ...mapGetters('diction',['getNewProductList','getAllProductPerson']),
        ...mapState('boss', ['accountTypes']),
        getUserList(){
            return this.getAllProductPerson.filter(function(item){
                // console.log(item)
                return item.label != ''
            })
        },
        TabsData(){
            return [
                {
                    name: "全部",
                    key:'EQ_status',
                    val: null
                }, {
                    name: "草稿",
                    key:'EQ_status',
                    val: 0,
                }, {
                    name: "待审核",
                    key:'EQ_status',
                    val: 1
                }, {
                    name: "已审核",
                    key:'EQ_status',
                    val: 2
                }, {
                    name: "已驳回",
                    key:'EQ_status',
                    val: 3
                }, {
                    name: "已取消",
                    key:'EQ_status',
                    val: 4
                }, {
                    name: "待转新品预选",
                    key:'daiyuzhuan',
                    val: 0
                }
            ]
        },
        // 左边的批量操作按钮
        ToolsData(){
            return [
                {
                    name: "新增",
                    operate: "add",
                    theme: "primary",
                },
                ,{
                    name: "查询条件导出",
                    theme: 'info',
                    operate: 'exportQuery',
                },
                {
                    name: "批量提交",
                    operate: 'allsubmit',
                    batch:true,
                    more: true
                },
                {
                    name: "批量审核",
                    operate: 'allaudit',
                    batch:true,
                    more: true
                },
                {
                    name: "批量取消",
                    operate: 'allcancel',
                    batch:true,
                    more: true
                },
                {
                    name: "批量驳回",
                    operate: "allrejected",
                    batch:true,
                    more: true
                }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData() {
            let widthStyle = 'width: 200px'
            return  [
                {
                    label: "标题",
                    tag: 'vInput',
                    key: 'CN_title',
                    show:true,
                },
                {
                    label: "推荐编号",
                    tag: 'vInput',
                    key: "EQ_id",
                    show: true,
                },
                {
                    label: "品类",
                    tag: 'vInput',
                    key: 'EQ_categoryId',
                    show: true,
                    props: {
                        readonly: true,
                        placeholder:this.$t('erp.product.select_category',{defaultValue:'请选择品类'}),
                    },
                    children: (h) => {
                        return <vIcon
                            title={this.$t('erp.product.search_category',{defaultValue:'搜索品类'})}
                            type="search"
                            center
                            slot="suffix"
                            style="padding:6px;pointer-events: initial;"
                            size="18"
                            nativeOnClick={this.handleModalplat}
                        />
                    }
                },
                {
                    label: "来源",
                    key: 'CN_source',
                    tag: "Select",
                    options:this.getSource,
                    style: widthStyle
                },
                {
                    label: "项目",
                    tag: 'Select',
                    key: 'IN_lineId',
                    options: this.getNewProductList,
                    props:{
                        filterable:true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: "单据状态",
                    tag: 'Select',
                    key: 'IN_status',
                    options: this.getRecommendStatus,
                    props:{
                        filterable:true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: "推荐理由",
                    tag: 'vInput',
                    key: 'CN_recommendReason',
                    style: widthStyle
                },
                {
                    label: "提交人",
                    tag: 'Select',
                    key: 'EQ_submitterName',
                    options:this.getUserList,
                    props:{
                        filterable:true,
                        clearable:true,
                    },
                    style: widthStyle
                },
                
                {
                    label: '审核人',
                    tag: 'Select',
                    key: 'EQ_reviewerName',
                    options:this.getUserList,
                    props:{
                        filterable:true,
                        clearable:true,
                    },
                    style: widthStyle
                },
                {
                    label: '目标站点',
                    key: 'IN_targetSite',
                    tag: "Select",
                    options: this.accountTypes.map(item=>{
                        return {
							value: item.name,
							label: item.name
						}
                    }),
                    props:{
                        filterable:true,
                        clearable:true,
                        multiple: true
                    },
                    style: widthStyle
                },
                {
                    label: "是否关联预选产品",
                    tag: 'Select',
                    key: 'EQ_isPreselection',
                    options:[
                        {label:'是',value:1},
                        {label:'否',value:0}
                    ],
                    style: widthStyle
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props:{
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    style: widthStyle
                },
                {
                    label: "部门",
                    tag: 'vInput',
                    key: 'CN_department',
                    style: widthStyle
                },
                {
                    label: "备注",
                    tag: 'vInput',
                    key: 'CN_remark',
                    style: widthStyle
                },
                {
                    label: "预选产品编号",
                    tag: 'vInput',
                    key: 'precoding',
                    style: widthStyle
                },
            ]
        },
        // table的展示数据
        columns() {
            return  [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            },{
                title: '操作',
                width: 90,
                render:this.getOperateNodes
            }, 
            {
                title: '编号',
                width: 60,
                key:'id',
            }, 
            {
                title: '品类/标题',
                key:'name',
                // sortable: true,
                render:(h,{row})=>{
                    const id = row.categoryId;
                    // const category = this.categoryList.filter((item) => {
                    //     return id == item.id
                    // })[0] || {};
                    if(row.categoryId){
                        return (
                        <div>
                            <div>
                                <div>{row.categoryCodeName || '--'}</div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.title}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                        )
                    }else{
                        return (
                        <div>
                            <div>
                                <div><a class="color-error" onClick={this.handleOperates.bind(this, row.id, 'uncategory')}>未关联</a></div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.title}</a>
                                <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><vIcon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                            </div>
                        </div>
                        )
                    }
                }
            },
            {
                title: '部门/提交人',
                key:'submitterName',
                render:(h, { row })=>{
                    return <div>
                        <div>{row.department || '--'}</div>  
                        <div>{row.submitterName || '--'}</div>    
                    </div>
                }
            },
            
            {
                title: '竞品链接',
                key:'competitiveLink',
                render:(h, { row })=>{
                    let competitiveArr= (row.competitiveLink || '').split(",");
                    return competitiveArr.map(item=>{
                        return <div><a href={item} target="_blank">{item}</a></div>
                    })
                }
            },
            {
                title: '单据状态',
                key:'status',
                render:(h,{row})=>this.findRenderLabel(this.getRecommendStatus,row.status,'label',true)
            },
            {
                title: '关联预选产品/预选产品状态',
                render:(h, { row })=>{
                    return (row.preselection||[]).map(item=>{
                        return <div><a onClick={this.handleOperates.bind(this, item.id, 'querypPrimaryBlank')}>{item.value}</a></div>
                    })
                }
            },
            {
                title: '提交/审核通过日期',
                // key: 'approvedTime',
                // sortable: true,
                render:(h, { row })=>{
                    return <div>
                        <div>{row.submitTime}</div>
                        <div>{row.approvedTime}</div>
                    </div>
                }
            },
            {
                title: '更新时间',
                key: 'updatedAt',
                sortable: true
            },
        ];
        },
        
    },

};
